module.exports = __webpack_public_path__ + "img/filter.58dc32a7.svg";